import { TRootState } from "Redux/Reducers";

export const getUserTicket = (id: string) => (state: TRootState) => state.userTicket.entries[id];
